var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgObjects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/24 Emoji/Objects") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/24-Emoji/Objects",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(4.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25,-0.75 C7.78390769,-0.75 7.3417524,-0.543558852 7.0425,-0.186221415 L-0.28283501,8.99420905 C-0.907295844,9.75867898 -0.907295844,10.8666129 -0.277452456,11.6377502 L7.03124832,20.7977495 C7.3417524,21.1688507 7.78390769,21.3752919 8.25,21.3752919 C8.71609231,21.3752919 9.1582476,21.1688507 9.4575,20.8115133 L16.782835,11.6310828 C17.4072958,10.8666129 17.4072958,9.75867898 16.7774525,8.98754163 L9.46875168,-0.17245762 C9.1582476,-0.543558852 8.71609231,-0.75 8.25,-0.75 Z M8.25,0.75 C8.27219487,0.75 8.29324989,0.759830531 8.3075,0.776846599 L15.6103317,9.92974947 C15.7945419,10.1553614 15.7945419,10.4699305 15.6157142,10.688875 L8.29624832,19.862209 L8.27118837,19.8726227 C8.26466993,19.8741996 8.25739829,19.8752919 8.25,19.8752919 C8.22780513,19.8752919 8.20675011,19.8654613 8.1925,19.8484453 L0.889668343,10.6955424 C0.705458074,10.4699305 0.705458074,10.1553614 0.884285789,9.93641689 L8.20375168,0.763082805 L8.22881163,0.752669111 C8.23533007,0.751092281 8.24260171,0.75 8.25,0.75 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3568252,9.5782721 C16.7634212,9.49919886 17.1571339,9.76470851 17.2362072,10.1713045 C17.308691,10.5440175 17.0916294,10.9059049 16.7417667,11.0245378 L16.6431748,11.0506864 L11.8306748,11.9866031 L11.6875,12.0003959 L4.8125,12.0003959 L4.66932524,11.9866031 L-0.143174764,11.0506864 C-0.549770753,10.9716132 -0.815280402,10.5779005 -0.736207163,10.1713045 C-0.663723361,9.7985915 -0.326855011,9.54443023 0.0419687965,9.56556483 L0.143174764,9.5782721 L4.883,10.5 L11.616,10.5 L16.3568252,9.5782721 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.53275993,-0.214511879 L4.09525993,11.0311548 C4.04748189,11.187459 4.05207089,11.3550922 4.10832867,11.5085485 L7.54582867,20.8851318 C7.78624682,21.5409284 8.71375318,21.5409284 8.95417133,20.8851318 L12.3916713,11.5085485 C12.4479291,11.3550922 12.4525181,11.187459 12.4047401,11.0311548 L8.96724007,-0.214511879 C8.75092166,-0.922190362 7.74907834,-0.922190362 7.53275993,-0.214511879 Z M8.25,2.57 L10.896,11.228 L8.25,18.447 L5.603,11.228 L8.25,2.57 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjects);
export default __webpack_public_path__ + "static/media/objects.d5f32382e5b1a4ab69763b0892fca717.svg";
export { ForwardRef as ReactComponent };